import * as React from 'react'
import { ILeaf, INode } from 'shared/types/tree'
import { getPresentationsWithSourceFile } from '../../../masters_management/utility'
import { Box, Button } from '@mui/material'
import { openNode } from '../../../utility/TreeNavigation'
import { openTab } from '../../../Helpers'
import { childNodesOfType } from '../../../utility/TreeHelpers'
import { NodeType } from 'shared/types/ingestion'
import { ConfirmCommitButton } from 'shared/ui'
import { PresentationSlidesView } from './SlidesView'
import { resolveSourceFileIssue } from './utility'

export function PresentationsViewOnly({ tree }: { tree: INode }) {
  const [presentations, setPresentations] = React.useState<INode[]>([])
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const [currentPresentation, setCurrentPresentation] = React.useState<INode>()

  React.useEffect(() => {
    setPresentations(getPresentationsWithSourceFile(tree))
    setCurrentIndex(0)
  }, [tree])

  React.useEffect(() => {
    const nextPres = presentations[currentIndex]
    setCurrentPresentation(nextPres)
    if (!nextPres) {
      setCurrentIndex(0)
    }
  }, [currentIndex, presentations])

  function next(forward: boolean) {
    let newIndex = (currentIndex + 1) % presentations.length
    if (!forward) {
      newIndex =
        (presentations.length + currentIndex - 1) % presentations.length
    }
    setCurrentIndex(newIndex)
  }
  if (!currentPresentation) return <Box>All looks ok</Box>

  function presentationUpdated(presentationId: string) {
    const filtered = presentations.filter((p) => p.id !== presentationId)
    setPresentations(filtered)
    setCurrentIndex(currentIndex % filtered.length)
  }

  function updateFail(_presentationId: string) {}

  return (
    <Box>
      <Box>{tree.title}</Box>
      <Box>{presentations.length} need to be fixed</Box>
      <Box>
        <Button onClick={() => next(false)}>{'<'}</Button>
        {currentIndex + 1}
        <Button onClick={() => next(true)}>{'>'}</Button>
      </Box>
      <Box>
        <Button onClick={() => openNode(currentPresentation)}>
          Open In Kiddom
        </Button>
        <Button
          onClick={() =>
            openTab(
              `/presentations_fix/${currentPresentation.tree_id}:${currentPresentation.version}`,
            )
          }
        >
          Open Fix
        </Button>
      </Box>
      <Box padding={'10px'}>
        <Presentation
          presentation={currentPresentation}
          onUpdate={() => presentationUpdated(currentPresentation.id)}
          onFail={() => updateFail(currentPresentation.id)}
        />
      </Box>
    </Box>
  )
}

function Presentation({
  presentation,
  onUpdate,
  onFail,
}: {
  presentation: INode
  onUpdate: () => void
  onFail: () => void
}) {
  const [presentationLeaf, setPresentationLef] = React.useState<ILeaf>()
  const [extraLeaves, setExtraLeaves] = React.useState<ILeaf[]>([])
  const [extraAttachmentsList, setExtraAttachmentsList] =
    React.useState<INode[]>()

  React.useEffect(() => {
    const [first, ...others] = childNodesOfType(
      presentation,
      NodeType.AttachmentsList,
    )
    setExtraAttachmentsList(others)
    if (first.leaves?.length) {
      const [leaf, ...otherLeaves] = first.leaves
      setPresentationLef(leaf)
      setExtraLeaves(otherLeaves)
    } else {
      setPresentationLef(undefined)
      setExtraLeaves([])
    }
  }, [presentation])

  function goToFile() {
    openTab(presentationLeaf?.body?.file?.url)
  }
  function goToSourceFile() {
    openTab(presentationLeaf?.body?.source_file?.url)
  }
  function updateToUrl(url: string) {
    if (!presentationLeaf) return
    resolveSourceFileIssue(url, presentation).catch(onFail)
    onUpdate()
  }

  return (
    <Box>
      <Box>
        File: {presentationLeaf?.body?.file?.url}
        <Box>
          <ConfirmCommitButton
            onClick={() => updateToUrl(presentationLeaf?.body?.file?.url)}
          >
            <>Use This</>
          </ConfirmCommitButton>
          <Button onClick={goToFile}>Open</Button>
        </Box>
        <PresentationSlidesView presentation={presentation} />
      </Box>
      <Box>
        Source File: {presentationLeaf?.body?.source_file?.url}
        <Box>
          <ConfirmCommitButton
            onClick={() =>
              updateToUrl(presentationLeaf?.body?.source_file?.url)
            }
          >
            <>Use This</>
          </ConfirmCommitButton>
          <Button onClick={goToSourceFile}>Open</Button>
        </Box>
        <PresentationSlidesView
          presentation={presentation}
          useSourceFile={true}
        />
      </Box>
      {!!extraLeaves?.length && (
        <Box>{extraLeaves.length} extra presentation links</Box>
      )}
      {!!extraAttachmentsList?.length && (
        <Box>{extraAttachmentsList.length} extra attachments list</Box>
      )}
    </Box>
  )
}
